module.exports = __webpack_public_path__ + "img/loading-cargando.440b9dc0.gif";